
import React from 'react';

// Icons
export const Logo = () => (
    <div className="flex items-center gap-2.5 dynamic-logo-color" role="img" aria-label="TAD-AI">
        <svg
            className="h-8 w-auto"
            viewBox="0 0 46 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <rect
                x="2"
                y="2"
                width="42"
                height="22"
                rx="11"
                stroke="currentColor"
                strokeWidth="4"
                fill="transparent"
            />
            <circle cx="16" cy="13" r="2.5" fill="currentColor" className="logo-eye" />
            <circle cx="30" cy="13" r="2.5" fill="currentColor" className="logo-eye" />
        </svg>
        <span className="font-bold text-xl tracking-wider">TAD-AI</span>
    </div>
);


export const TitleIcon = () => <img src="https://picsum.photos/seed/stock-icon/20/20?grayscale" alt="icon" className="rounded-full" />;
export const SparkleIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.8">
            <path d="M8 1.33301L9.12132 5.87834L10.6667 6.99967L9.12132 8.121L8 12.6663L6.87868 8.121L5.33333 6.99967L6.87868 5.87834L8 1.33301Z" stroke="white" strokeWidth="1" />
            <path d="M13.3333 0L14.0404 3.04043L16 3.74744L14.0404 4.45446L13.3333 7.49489L12.6263 4.45446L10.6667 3.74744L12.6263 3.04043L13.3333 0Z" stroke="white" strokeWidth="0.5" />
            <path d="M13.3333 10.1719L14.0404 13.2123L16 13.9193L14.0404 14.6263L13.3333 17.6667L12.6263 14.6263L10.6667 13.9193L12.6263 13.2123L13.3333 10.1719Z" stroke="white" strokeWidth="0.5" />
        </g>
    </svg>
);

const commonIconClass = "w-12 h-12";
const AIPoweredRecommendationsIcon = () => <img src="/images/AI powered recommendations.svg" alt="AI powered recommendations icon" className={commonIconClass} />;
const RealTimeMarketIcon = () => <img src="/images/real time market.svg" alt="Real time market icon" className={commonIconClass} />;
const PortfolioOptimizationIcon = () => <img src="/images/portfolio optimization.svg" alt="Portfolio optimization icon" className={commonIconClass} />;
const MarketAnalysisIcon = () => <img src="/images/market analysis.svg" alt="Market analysis icon" className={commonIconClass} />;
const AdvancedTechnicalAnalysisIcon = () => <img src="/images/Advanced Technical analysis.svg" alt="Advanced technical analysis icon" className={commonIconClass} />;
const CustomizableAlertIcon = () => <img src="/images/customizable alert.svg" alt="Customizable alert icon" className={commonIconClass} />;

export const DeepAnalysisEngineIcon = () => <img src="/images/deep analysis engine.svg" alt="Deep analysis engine icon" className="w-full h-auto max-w-xs" />;
export const RiskManagementIcon = () => <img src="/images/risk management.svg" alt="Risk management icon" className={commonIconClass} />;
export const SeamlessIntegrationIcon = () => <img src="/images/seamless integration.svg" alt="Seamless integration icon" className={commonIconClass} />;


export const ArrowDownIcon = () => (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.833008 1.33301L4.99967 4.66634L9.16634 1.33301" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const ArrowRightIcon = () => (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="arrow-rtl-flip">
        <path d="M8.45801 1.25L13.1663 6L8.45801 10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.16699 6H13.167" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const GoogleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
    </svg>
);

export const AppleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.59 15.3c-1.12 0-2.02.78-2.52 1.83-.82 1.7-2.03 3.3-3.69 3.3-1.48 0-2.39-1.15-3.83-1.15-1.57 0-2.79 1.22-3.83 1.22-.92 0-1.87-.9-2.72-2.3-.92-1.52-1.28-4.32.1-7.02 1.1-2.2 3.08-3.59 5.23-3.59 1.48 0 2.62.98 3.53.98.92 0 2.23-1.08 3.8-1.08 1.83 0 3.21 1.2 4.24 1.2.14 0 .28.02.41.03-.02-.01-2.05.82-2.05 3.33 0 2.22 1.5 3.22 2.08 3.49-.1.17-.61 1.12-1.74 2.58zm-5.74-13.3c.7-.84 1.17-1.95 1.03-3-1.18.06-2.43.76-3.18 1.59-.68.74-1.22 1.95-1.05 2.99 1.24-.04 2.52-.73 3.2-1.58z" />
    </svg>
);

export const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
);

export const SuccessIcon = () => (
    <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="stroke-current text-teal-400">
        <path d="M22 11.08V12C21.99 14.22 21.32 16.38 20.07 18.2C18.82 20.02 17.06 21.41 15 22.13C12.94 22.85 10.71 22.86 8.59 22.15C6.47 21.44 4.69 20.06 3.43 18.25C2.17 16.44 1.5 14.29 1.5 12C1.5 9.71 2.17 7.56 3.43 5.75C4.69 3.94 6.47 2.56 8.59 1.85C10.71 1.14 12.94 1.15 15 1.87" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22 4L12 14.01L9 11.01" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const ErrorIcon = () => (
    <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="stroke-current text-red-500">
        <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.17004 14.83L14.83 9.17004" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.83 14.83L9.17004 9.17004" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);


// Data for Features section
export const featuresData = [
    { icon: <AIPoweredRecommendationsIcon />, titleKey: 'feature1Title', descriptionKey: 'feature1Desc' },
    { icon: <RealTimeMarketIcon />, titleKey: 'feature2Title', descriptionKey: 'feature2Desc' },
    { icon: <PortfolioOptimizationIcon />, titleKey: 'feature3Title', descriptionKey: 'feature3Desc' },
    { icon: <MarketAnalysisIcon />, titleKey: 'feature4Title', descriptionKey: 'feature4Desc' },
    { icon: <AdvancedTechnicalAnalysisIcon />, titleKey: 'feature5Title', descriptionKey: 'feature5Desc' },
    { icon: <CustomizableAlertIcon />, titleKey: 'feature6Title', descriptionKey: 'feature6Desc' },
];

// Data for Pricing section
export const PricingIconStarter = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.8856 9.11467L16 4L9.11438 9.11467L4 16L9.11438 22.8857L16 28L22.8856 22.8857L28 16L22.8856 9.11467Z" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19.4282 12.5713L12.5712 19.4283" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19.4282 19.4283L12.5712 12.5713" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export const PricingIconMedium = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="14" cy="14" r="6" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" />
        <path d="M18 18L21 21" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M16 5V3" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M27 16H29" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M16 27V29" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M5 16H3" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);
export const PricingIconBusiness = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 10L10 22" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 10L22 22" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19 3H29V13" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13 29H3V19" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const FeatureCheckIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3_40)">
            <path d="M9.99935 18.3337C14.6017 18.3337 18.3327 14.6027 18.3327 10.0003C18.3327 5.39795 14.6017 1.66699 9.99935 1.66699C5.39698 1.66699 1.66602 5.39795 1.66602 10.0003C1.66602 14.6027 5.39698 18.3337 9.99935 18.3337Z" fill="#8B5CF6" fillOpacity="0.2" />
            <path d="M7.08398 10.0003L9.16732 12.0837L12.9173 8.33366" stroke="#C084FC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_3_40">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const pricingPlans = [
    {
        nameKey: 'plan1Name',
        price: { monthly: '99', annual: '990' },
        icon: <PricingIconStarter />,
        featuresKeys: [
            'plan1Feature1',
            'plan1Feature2',
            'plan1Feature3',
            'plan1Feature4',
            'plan1Feature5'
        ]
    },
    {
        nameKey: 'plan2Name',
        price: { monthly: '299', annual: '2990' },
        icon: <PricingIconMedium />,
        featuresKeys: [
            'plan2Feature1',
            'plan2Feature2',
            'plan2Feature3',
            'plan2Feature4',
            'plan2Feature5'
        ]
    },
    {
        nameKey: 'plan3Name',
        price: { monthly: '999', annual: '9990' },
        icon: <PricingIconBusiness />,
        featuresKeys: [
            'plan3Feature1',
            'plan3Feature2',
            'plan3Feature3',
            'plan3Feature4',
            'plan3Feature5'
        ]
    }
];

// Data for Testimonials
export const testimonials = [
    { nameKey: 'testimonial1Name', handle: '@fahad_trade', avatarUrl: 'https://picsum.photos/seed/user1/48/48', textKey: ['testimonial1Text1'] },
    { nameKey: 'testimonial2Name', handle: '@noura.invest', avatarUrl: 'https://picsum.photos/seed/user2/48/48', textKey: ['testimonial2Text1', 'testimonial2Text2'] },
    { nameKey: 'testimonial3Name', handle: '@yasir.markets', avatarUrl: 'https://picsum.photos/seed/user3/48/48', textKey: ['testimonial3Text1'] },
    { nameKey: 'testimonial4Name', handle: '@khaled.advisor', avatarUrl: 'https://picsum.photos/seed/user4/48/48', textKey: ['testimonial4Text1'] },
    { nameKey: 'testimonial5Name', handle: '@reem.b', avatarUrl: 'https://picsum.photos/seed/user5/48/48', textKey: ['testimonial5Text1', 'testimonial5Text2'] },
    { nameKey: 'testimonial6Name', handle: '@sultan_z', avatarUrl: 'https://picsum.photos/seed/user6/48/48', textKey: ['testimonial6Text1'] },
    { nameKey: 'testimonial7Name', handle: '@lailah', avatarUrl: 'https://picsum.photos/seed/user7/48/48', textKey: ['testimonial7Text1'] },
    { nameKey: 'testimonial8Name', handle: '@majedf', avatarUrl: 'https://picsum.photos/seed/user8/48/48', textKey: ['testimonial8Text1'] },
    { nameKey: 'testimonial9Name', handle: '@sara.gh', avatarUrl: 'https://picsum.photos/seed/user9/48/48', textKey: ['testimonial9Text1'] },
    { nameKey: 'testimonial1Name', handle: '@adison', avatarUrl: 'https://picsum.photos/seed/user10/48/48', textKey: ['testimonial1Text1'] },
    { nameKey: 'testimonial2Name', handle: '@zain', avatarUrl: 'https://picsum.photos/seed/user11/48/48', textKey: ['testimonial2Text1', 'testimonial2Text2'] },
    { nameKey: 'testimonial3Name', handle: '@machel', avatarUrl: 'https://picsum.photos/seed/user12/48/48', textKey: ['testimonial3Text1'] },
];

// Data for Client Logos
export const clientLogos = [
    <img src="images/شركة أديس.svg" alt="Client Logo 1" />,
    <img src="images/شركة أرامكو.svg" alt="Client Logo 2" />,
    <img src="images/شركة البحري.svg" alt="Client Logo 3" />,
    <img src="images/شركة الحفر العربيه.svg" alt="Client Logo 4" />,
    <img src="images/شركة الدريس.svg" alt="Client Logo 5" />,
    <img src="images/شركة_المصافي_العربية_السعودية.svg" alt="Client Logo 1" />, // repeat for scrolling effect
];

// Blog Data
export const UserIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8ZM8 10C5.33333 10 0 11.3333 0 14V16H16V14C16 11.3333 10.6667 10 8 10Z" fill="currentColor" /></svg>
);
export const CalendarIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 2H13V0H11V2H5V0H3V2H2C1.45 2 1 2.45 1 3V14C1 14.55 1.45 15 2 15H14C14.55 15 15 14.55 15 14V3C15 2.45 14.55 2 14 2ZM13 13H3V6H13V13Z" fill="currentColor" /></svg>
);
export const blogPosts = [
    {
        id: 'static-1',
        slug: 'saudi-energy-sector-ai',
        imageUrl: 'https://picsum.photos/seed/blog1/370/260',
        tagsKeys: ['blogTagAnalysis', 'blogTagEnergy'],
        titleKey: 'blog1Title',
        excerptKey: 'blog1Excerpt',
        contentKey: 'blog1Excerpt',
        authorKey: 'blog1Author',
        date: 'Oct 25, 2023',
    },
    {
        id: 'static-2',
        slug: 'fintech-ai-investment',
        imageUrl: 'https://picsum.photos/seed/blog2/370/260',
        tagsKeys: ['blogTagFintech', 'blogTagAI'],
        titleKey: 'blog2Title',
        excerptKey: 'blog2Excerpt',
        contentKey: 'blog2Excerpt',
        authorKey: 'blog2Author',
        date: 'Oct 19, 2023',
    },
    {
        id: 'static-3',
        slug: 'long-term-investment-strategy',
        imageUrl: 'https://picsum.photos/seed/blog3/370/260',
        tagsKeys: ['blogTagInvesting', 'blogTagStrategy'],
        titleKey: 'blog3Title',
        excerptKey: 'blog3Excerpt',
        contentKey: 'blog3Excerpt',
        authorKey: 'blog3Author',
        date: 'Oct 12, 2023',
    },
];

// Footer Data
export const FacebookIcon = () => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6667 19.1667V10.8333H14.1667L14.5833 8.33333H11.6667V6.66667C11.6667 5.95833 11.8333 5.41667 12.9167 5.41667L14.6667 5.41667V3.08333C14.4167 3.04167 13.5 3 12.5 3C10.4167 3 9.16667 4.25 9.16667 6.33333V8.33333H6.66667V10.8333H9.16667V19.1667H11.6667Z" fill="currentColor" /></svg>);
export const TwitterIcon = () => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.1667 4.54167C18.5 4.83333 17.8333 5.04167 17.0833 5.125C17.8333 4.66667 18.375 4 18.6667 3.16667C17.9583 3.58333 17.1667 3.91667 16.3333 4.125C15.6667 3.41667 14.6667 3 13.5833 3C11.5 3 9.83333 4.66667 9.83333 6.75C9.83333 7.04167 9.875 7.33333 9.91667 7.58333C6.75 7.41667 4 5.95833 2.125 3.75C1.79167 4.33333 1.58333 5 1.58333 5.75C1.58333 7 2.25 8.08333 3.25 8.75C2.66667 8.70833 2.08333 8.58333 1.58333 8.33333V8.375C1.58333 10.1667 2.875 11.625 4.58333 11.9583C4.29167 12.0417 3.95833 12.0833 3.625 12.0833C3.375 12.0833 3.16667 12.0417 2.91667 12C3.375 13.4583 4.83333 14.5417 6.54167 14.5833C5.29167 15.5417 3.70833 16.125 2.08333 16.125C1.79167 16.125 1.5 16.125 1.25 16.0833C2.95833 17.1667 4.95833 17.8333 7.125 17.8333C13.5833 17.8333 17.3333 12.5417 17.3333 8C17.3333 7.83333 17.3333 7.66667 17.3333 7.5C17.9583 7.04167 18.5833 6.45833 19.1667 5.75C18.5833 6.04167 17.9167 6.25 17.25 6.33333C17.9583 5.875 18.5 5.16667 18.75 4.33333L19.1667 4.54167Z" fill="currentColor" /></svg>);
export const GithubIcon = () => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0C4.475 0 0 4.475 0 10C0 14.425 2.8625 18.15 6.8375 19.4875C7.3375 19.575 7.525 19.275 7.525 19.0125C7.525 18.775 7.5125 17.9875 7.5125 17.15C4.9125 17.6375 4.3 15.9375 4.3 15.9375C3.85 14.8 3.125 14.475 3.125 14.475C2.2 13.825 3.2 13.8375 3.2 13.8375C4.2125 13.9125 4.8 14.8625 4.8 14.8625C5.7 16.45 7.2375 15.975 7.825 15.7125C7.9125 15.0625 8.175 14.6125 8.45 14.375C6.1625 14.125 3.7625 13.2625 3.7625 9.5C3.7625 8.4 4.15 7.525 4.8 6.8625C4.7 6.6125 4.35 5.5125 4.9 4.2C4.9 4.2 5.7375 3.925 7.525 5.15C8.325 4.925 9.175 4.8125 10.025 4.8125C10.875 4.8125 11.725 4.9375 12.525 5.15C14.3125 3.925 15.15 4.2 15.15 4.2C15.7 5.5125 15.35 6.6125 15.25 6.8625C15.9 7.525 16.2875 8.4 16.2875 9.5C16.2875 13.275 13.8875 14.125 11.5875 14.375C11.9375 14.675 12.2125 15.225 12.2125 16.1C12.2125 17.3625 12.2 18.375 12.2 18.775C12.2 19.0375 12.3875 19.2875 12.8875 19.2C17.1375 18.15 20 14.425 20 10C20 4.475 15.525 0 10 0Z" fill="currentColor" /></svg>);

export const footerLinks = {
    footerSiteTitle: ['footerMarket', 'footerNews', 'footerFeatures', 'footerPricing'],
    footerPlatformTitle: ['footerDashboard', 'footerBotGeneral', 'footerBotVip', 'footerBotSupport'],
    footerCompanyTitle: ['footerAbout', 'footerHelp', 'footerStatus', 'footerChangelog'],
    footerLegalTitle: ['footerPrivacy', 'footerRefund', 'footerTelegramChannel', 'footerWhatsApp']
};
